import { render } from "./BankRatesSetting.vue?vue&type=template&id=78f65dcc&ts=true"
import script from "./BankRatesSetting.vue?vue&type=script&lang=ts"
export * from "./BankRatesSetting.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__